import jQuery from "jquery";
window.jQuery = window.$ = jQuery;

import * as bootstrap from "bootstrap";

import "./onboarding/swal";
import "./onboarding/ajax";
import "./onboarding/inputmask";

import "./onboarding/custom";

import "./common/sentry";
